module.exports = "\n/* set app to full viewport height, disable scrolling of root element by setting to 'fixed'\nthis effectivaly prevents overscrolling on ipand and iphones\n*/\n  #app {\n    width: 100%;\n    height: 100%;\n    z-index: 0;\n    position: fixed;\n    overflow: hidden;\n  }\n  @media (min-width: 992px) {\n    .app-boxed-page #app {\n      margin: 0 auto;\n      width: 970px;\n    }\n  }\n  @media (min-width: 1200px) {\n    .app-boxed-page #app {\n      margin: 0 auto;\n      width: 1170px;\n    }\n  }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main